'use client';

import * as React from 'react';
import Heading from '../elements/heading';
import { CoursePromoCard } from '../elements/course-promo-card';
import { FeaturedCourses } from '../../types/blocks/featured-courses';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { commonSwiperConfig } from '@/shared/utils';
import { useRouter } from 'next/navigation';

interface FeaturedCoursesProps {
  element: FeaturedCourses;
}

export const SectionFeaturedCourses: React.FC<FeaturedCoursesProps> = ({ element }) => {
  const router = useRouter();
  console.log('ECCOMI!', element.items[0]);

  return (
    <div className="py-24 space-y-16">
      <Heading
        title={element.title}
        subtitle={element.description}
        className="max-w-[600px] mx-auto px-4 md:px-[40px] lg:px-[88px] m-0 space-y-4"
      />

      <div className="relative w-screen">
        <div className="absolute left-0 bottom-0 h-full w-32 bg-gradient-to-r from-[#1C1D22] to-transparent z-10" />
        <div className="absolute right-0 bottom-0 h-full w-32 bg-gradient-to-l from-[#1C1D22] to-transparent z-10" />
        <Swiper
          {...commonSwiperConfig}
          spaceBetween={16}
          slidesPerView="auto"
          watchOverflow={false}
          centeredSlides={true}
          initialSlide={Math.floor(element.items.length / 2)}
          loop
        >
          {element.items.map((course, index) => (
            <SwiperSlide key={index} className="w-[240px] h-[300px]">
              <CoursePromoCard
                title={course.description}
                onDetailsClick={() => {
                  if (course.callToAction?.href) {
                    router.push(course.callToAction.href);
                  }
                }}
                callToAction={course.callToAction}
                mediaList={course.mediaList}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
